// Pure logic for the READY-meal modal lifecycle (kept router/React-free so it is unit-testable).
// An already-open READY modal must auto-close the moment its job leaves READY (committed/discarded/
// retried) or disappears — so a stale "ready to review" modal never stays covering Home after the user
// logs the meal from Review.
export function shouldCloseOpenReadyModal(modalJob, jobs) {
  if (!modalJob) return false;
  const cur = (jobs || []).find((j) => j.job_id === modalJob.job_id);
  return !cur || cur.status !== 'ready';
}
